import request from "@/utils/request";

export function getCities() {
  return request({
    url: `/api/Cities/GetCities`,
    method: `get`,
  });
}

export function getCityId(id, params) {
  return request({
    url: `/api/Cities/GetCity/${id}`,
    method: `get`,
    params,
  });
}

export function postCity(data) {
  return request({
    url: `/api/Cities/CreateCity`,
    method: `post`,
    data,
  });
}

export function putCityId(id, data, params = id) {
  return request({
    url: `/api/Cities/UpdateCity/${id}`,
    method: `put`,
    params,
    data,
  });
}

export function deleteCity(id, params) {
  return request({
    url: `/api/Cities/DeleteCity/${id}`,
    method: "delete",
    params,
  });
}
